module.exports = __webpack_public_path__ + "static/threeDPrinter-c6b11e6a829c2c082fcb4c89a3bc3d8b.svg";